import "./team-dropdown-menu.scss";

import React, { useState } from "react";
import classNames from "classnames";

const TeamDropdownMenu = ({ team }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div
      className={classNames("team-dropdown", {
        [`team-dropdown--opened`]: isOpen,
      })}
      onClick={(e) => setIsOpen(!isOpen)}
      aria-hidden="true"
    >
      <div className="team-dropdown__select">
        <img
          src={require("assets/icons/team-phone.png").default}
          className="team-dropdown__icon"
          alt=""
        />
        Telefon do naszego doradcy handlowego <br />
        (kliknij tutaj)
      </div>
      <div className="team-dropdown__content">
        {team?.map((node, index) => {
          const person = node.node.singleTeam;
          return (
            <div className="team-dropdown__single-person" key={index}>
              <img
                src={person.avatar?.sourceUrl}
                className="team-dropdown__avatar img-fluid"
                alt=""
              />
              <div className="team-dropdown__name-container">
                <div className="team-dropdown__name">{person.fullname}</div>
                <a
                  href={`mailto:${person.email}`}
                  className="team-dropdown__email"
                >
                  {person.email}
                </a>
                <a
                  href={`tel:${person.phone}`}
                  className="team-dropdown__phone team-dropdown__phone--mobile"
                >
                  {person.phone}
                </a>
              </div>
              <a href={`tel:${person.phone}`} className="team-dropdown__phone">
                {person.phone}
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TeamDropdownMenu;
